import { Component, OnInit } from '@angular/core';
import { AcessibilidadeService } from '../acessibilidade.service';
import { environment } from '../../../../environments/environment';

@Component({
  selector: 'barra-acessibilidade',
  templateUrl: './barra-acessibilidade.component.html',
  styleUrls: ['./barra-acessibilidade.component.scss'],
})
export class BarraAcessibilidadeComponent implements OnInit {

  environment = environment;
  contraste = false;
  tamanhoFonteSelecionado = 16;

  constructor(private acessibilidadeService: AcessibilidadeService) { }

  ngOnInit() { }

  ativarContraste() {
    this.contraste = !this.contraste;
    const sourceLogo = document.querySelector('body header#header a.ceuma-logo picture source');
    const imgLogo = document.querySelector('body header#header a.ceuma-logo picture img');
    if (this.contraste) {
      sourceLogo.setAttribute('src', `/assets/images/${environment.loginContexto.toLowerCase()}_branco.png`);
      imgLogo.setAttribute('src', `/assets/images/${environment.loginContexto.toLowerCase()}_branco.png`);
    } else {
      sourceLogo.setAttribute('src', `/assets/images/${environment.loginContexto.toLowerCase()}_header.png`);
      imgLogo.setAttribute('src', `/assets/images/${environment.loginContexto.toLowerCase()}_header.png`);
    }
    document.querySelector('body').classList.toggle('contraste');
  }

  alterarTamanhoFonte(tamanhoFonte) {
    if (this.tamanhoFonteSelecionado !== tamanhoFonte) {
      this.tamanhoFonteSelecionado = tamanhoFonte;
      this.acessibilidadeService.atualizarTamanhoFonte(tamanhoFonte);
    }
    this.acessibilidadeService.classesTamanhoFonte(tamanhoFonte);
  }
}
